import './home.css';

import React, { useEffect } from 'react';
import {
    Tokens,
} from 'services/SystemNames';
import SourceApiRepository from "repositories/api/SourceApiRepository";
import MetaIdbRepository from "repositories/idb/MetaIdbRepository";
import { useNavigate } from 'react-router';
import Overlay from 'components/layout/overlay/Overlay';
import { isImpersonating, impersonateId } from 'components/helpers/AuthHelpers';
import { useSetApplicationRights, useSetConfiguration, useSetServiceWorkerRegistration, useSetMapEvent, useSetNotificationMessage } from "components/hooks/useAppStore";

function Logout() {

    const navigate = useNavigate();

    const setApplicationRights = useSetApplicationRights();
    const setConfiguration = useSetConfiguration();
    const setServiceWorkerRegistration = useSetServiceWorkerRegistration();
    const setMapEvent = useSetMapEvent();
    const setNotificationMessage = useSetNotificationMessage();
    
    useEffect(() => {

        const initialize = async () => {
            if(isImpersonating()) {
                await SourceApiRepository.stopImpersonateTokenByPersonIdAsync(impersonateId());
            }

            localStorage.removeItem(Tokens.Token);
            await MetaIdbRepository.deleteWhoAmIAsync();

            // Clear AppStore values
            setApplicationRights(null);
            setConfiguration(null);
            setServiceWorkerRegistration(null);
            setMapEvent(null);
            setNotificationMessage(null);

            navigate("/");
        }

        initialize();
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Overlay isBusy={true}/>
    );

    
}

export default Logout;
